interface IProfile {
  name: string;
  country: string;
  phoneNumber?: string;
}

export { IProfile }
